import React, { useContext } from "react";
import AreaTipoDivergenciaEnum from "../../../AreaTipoDivergenciaEnum";
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from "../../../template/FinalStepTemplate";
import {
  buildMultiploMaterialInfoComponent,
  TecidoProps,
} from "../../../template/TecidoQuantidadeStepTemplate";
import useBuildSubmitHandler from "../../../template/UseBuildSubmitHandler";

import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";
import TipoDivergenciasKey from "../../../TipoDivergenciasKey";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";

import {
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Typography,
} from "@material-ui/core";
import {
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon,
} from "@material-ui/icons";
import {
  DivergenceContext,
  DivergenceContextType,
  FileProps,
} from "../../../../../../../context";
import { DELETE_FILE_MUTATION } from "../../../template/UploadStepTemplate";
import { useMutation } from "@apollo/client";
import UploadQuantidadeTecidoTrianguladoStep from "../../upload-step/UploadQuantidadeTecidoTrianguladoStep";
import { useSnackbar } from "notistack";

const QuantidadeTecidoTrianguladoFinalStep: TipoDivergenciaComponent<TecidoProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {
  const onBackHandler = () => {
    onBack({
      component: UploadQuantidadeTecidoTrianguladoStep as TipoDivergenciaComponent,
      payload: payload,
    });
  };

  const {
    files: filesDivergencia,
    truncateString,
    formatFileSize,
    setFiles,
    files,
  } = useContext<DivergenceContextType>(DivergenceContext);
  const [deleteFile] = useMutation(DELETE_FILE_MUTATION);
  const { enqueueSnackbar } = useSnackbar();

  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.QUALIDADE_MP_TRIANGULACAO,
      "Qtde de tecido triangulado recebida diferente da nota fiscal"
    ),
    ...buildMultiploMaterialInfoComponent(payload),
    ...filesDivergencia.map((file: FileProps, index) => (
      <ListItem key={index} button>
        <ListItemIcon>
          {file.type === "pdf" ? <PdfIcon /> : <FileIcon />}
        </ListItemIcon>
        <ListItemText
          primary={truncateString(file.name as string, 18)}
          secondary={formatFileSize(file.size ? file.size : 0)}
        />
        <IconButton edge="end">
          <Typography
            variant="caption"
            color="primary"
            onClick={() => {
              const variables = { variables: { filename: file.fileId } };

              deleteFile(variables)
                .then(() => {
                  setFiles(
                    files.filter((fileOld: any) => fileOld.path !== file.path)
                  );
                })
                .catch((error) => {
                  console.error(error);
                  enqueueSnackbar("Erro ao deletar arquivo. Tente novamente.", {
                    variant: "error",
                    preventDuplicate: true,
                  });
                });
            }}
          >
            Deletar
          </Typography>
        </IconButton>
      </ListItem>
    )),
  ];

  const key = TipoDivergenciasKey.MP_QUANTIDADE_TECIDO_TRIANGULADO_DIFERENTE_NOTA_FISCAL;
  const { loadingSave, loadingTipoDivergencia, handleSubmit } =
    useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      infoMessage={
        <span>
          <strong>Atenção:</strong> Por favor, informe nos comentários o pedido de matéria-prima, a NF recebida e a quantidade divergente.
        </span>
      }
      onSetStep={(step) => {
        handleSubmit(
          step,
          payload.tecidos.map((item) => ({
            tipo: TipoDivergenciasInfoKey.TECIDO,
            value: item.id.toString(),
            filesDivergencia: filesDivergencia,
            material: item.material,
          }))
        );
      }}
      progressValue={90}
      stepNumber={"3"}
      infoComponents={infoComponents}
    />
  );
};

export default QuantidadeTecidoTrianguladoFinalStep;
